import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { LeftMenuItemModel } from '@sb-tools/typescript/models/left-menu-item.model';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { ShortNumberPipe } from '../../../shared/pipes/short-number.pipe';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { TicketRightPanelService } from '../../../core/services/ticket-right-panel.service';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { CollapseDirective } from '../../../../sb-tools/typescript/directives/collapse.directive';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgClass } from '@angular/common';
import { SafeHtmlPipe } from '../../../../sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'app-left-menu-item',
    templateUrl: './left-menu-item.component.html',
    styleUrls: ['./left-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CollapseDirective, InlineSVGComponent, TranslateModule, TooltipModule, RouterLink, NgClass, SafeHtmlPipe],
})
export class LeftMenuItemComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild('leftMenuLinkTooltip') leftMenuLinkTooltip;

    @Input() countUpdateMarker;
    @Input() item: LeftMenuItemModel;

    communityName;
    count: number | string = 0;
    folderStat;
    isLinkActive;
    ticketSourceEnum = TicketSource;
    ticketStatusEnum = TicketStatus;
    unhandledRepliesCount: number | string = 0;

    private queryParams = {};
    private tooltipTimer;
    private unsubscriber = new Subject<void>();

    constructor(
        private commonDataService: CommonDataService,
        private activatedRoute: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        private ticketRightPanelService: TicketRightPanelService,
    ) {}

    ngOnInit() {
        this.communityName = this.commonDataService.communityName;
        this.folderStat = this.commonDataService.folderStat;

        if (this.item.queryParams) {
            this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
                this.queryParams = params;
                this.isLinkActive = this.getLinkActiveState(this.item.queryParams);
                this.changeDetectorRef.detectChanges();
            });
        }

        this.checkLinkClick = this.checkLinkClick.bind(this);
    }

    ngOnChanges() {
        this.count = this.getCount(this.item.folderNames);
        if (!this.item.hasNoCountProperties) {
            this.unhandledRepliesCount = this.getCount(this.item.folderNames, 'unhandledRepliesCount');
        }
    }

    checkLinkClick(event) {
        if (!this.ticketRightPanelService.isNeedToDiscardUnsavedChanges()) {
            event.stopPropagation();
            event.preventDefault();
            event.cancelBubble = true;
            event.stopImmediatePropagation();
            return;
        }

        if (
            $(event.target).closest('.link-content-wrapper').length &&
            $(event.target).closest('a').hasClass('active') &&
            !event.metaKey &&
            !event.ctrlKey
        ) {
            event.stopPropagation();
            return false;
        }
    }

    getCount(folderNames, countProperty: 'totalCount' | 'unhandledRepliesCount' = 'totalCount') {
        let count;

        if (this.commonDataService.folderStat && folderNames) {
            try {
                count = this.commonDataService.folderStat[folderNames[0]];

                for (let i = 1; i < folderNames.length; ++i) {
                    count = count[folderNames[i]];
                }

                if (this.item.hasNoCountProperties) {
                    return new ShortNumberPipe().transform(count);
                } else {
                    return new ShortNumberPipe().transform(count[countProperty]);
                }
            } catch {
                return 0;
            }
        } else {
            return 0;
        }
    }

    hideTooltip() {
        clearTimeout(this.tooltipTimer);
        this.leftMenuLinkTooltip.hide();
    }

    showTooltip() {
        this.tooltipTimer = setTimeout(() => {
            this.leftMenuLinkTooltip.show();
        }, 500);
    }

    private getLinkActiveState(mainParams): boolean {
        const mainKeys = Object.keys(mainParams);
        const queryParamsKeys = Object.keys(this.queryParams);

        if (this.queryParams['filterId']) {
            if (+this.queryParams['filterId'] === mainParams.filterId) {
                return true;
            } else {
                return false;
            }
        }

        let isLinkActive = true;

        outer: for (const [index, keys] of [queryParamsKeys, mainKeys].entries()) {
            const keysForCheck = index === 0 ? mainKeys : queryParamsKeys;

            for (const key of keys) {
                if (!['status', 'ticketId', 'orderBy'].includes(key)) {
                    if (
                        !keysForCheck.includes(key) ||
                        this.queryParams[key].toString() !== mainParams[key].toString()
                    ) {
                        isLinkActive = false;
                        break outer;
                    }
                }
            }
        }

        return isLinkActive;
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
